import { render } from "./MultiVentanas.vue?vue&type=template&id=fb35377a&scoped=true"
import script from "./MultiVentanas.vue?vue&type=script&lang=js"
export * from "./MultiVentanas.vue?vue&type=script&lang=js"

import "./MultiVentanas.vue?vue&type=style&index=0&id=fb35377a&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb35377a"]])

export default __exports__